export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8297.40928f15.jpg";